module.exports = __webpack_public_path__ + "d39c7b6295a1ff7a9d2f7db9a13616f2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/bookshelves/bookshelf-circus.png
// module id = 1565
// module chunks = 0